import { render } from "./DaftarPDOIOS.vue?vue&type=template&id=9f78227a"
import script from "./DaftarPDOIOS.vue?vue&type=script&lang=js"
export * from "./DaftarPDOIOS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__